import { supabase } from './supabase';

/**
 * Saves the Contact page "Send us a Message" form via Supabase RPC.
 */
export async function submitContactMessage({ name, email, phone, subject, message }) {
  const { data, error } = await supabase.rpc('submit_contact_message', {
    p_name: name,
    p_email: email,
    p_phone: phone || null,
    p_subject: subject,
    p_message: message,
  });

  if (error) {
    throw new Error(error.message || 'Could not send message');
  }

  if (!data || data.success !== true) {
    throw new Error(data?.error || 'Could not send message');
  }

  return data;
}
